export const variant1 = 'variant1';
export const variant2 = 'variant2';
